import { render, staticRenderFns } from "./Apart.vue?vue&type=template&id=b5f0ec0c"
import script from "./Apart.vue?vue&type=script&lang=js"
export * from "./Apart.vue?vue&type=script&lang=js"
import style0 from "./Apart.vue?vue&type=style&index=0&id=b5f0ec0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports